export function initStickyHeaderHeightVar(headerElement, cssVarName = '--sticky-header-height') {
    if (!headerElement) {
        return;
    }

    const updateVar = () => {
        const height = headerElement.getBoundingClientRect().height;
        document.documentElement.style.setProperty(cssVarName, height + 'px');
    };

    updateVar();

    const observer = new ResizeObserver(updateVar);
    observer.observe(headerElement);
}

export function initStickyState(element, className = 'is-sticky') {
    if (!element) {
        return;
    }

    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.height = '0';
    element.insertAdjacentElement('beforebegin', sentinel);

    let observer;

    function setup() {
        if (observer) {
            observer.disconnect();
        }

        const stickyTop = parseInt(getComputedStyle(element).top) || 0;

        observer = new IntersectionObserver(
            ([entry]) => {
                element.classList.toggle(className, !entry.isIntersecting);
            },
            {
                threshold: 0,
                rootMargin: `-${stickyTop}px 0px 0px 0px`
            }
        );

        observer.observe(sentinel);
    }

    setup();
    window.addEventListener('resize', setup);
}
